<template>
	<div>
		<component
			v-if="nativeComponent"
			:is="nativeComponent"
			ref="nativeReportRef"
		/>
		<PowerBIReport
			v-else
			:id="decodedIDs.reportID"
			:company-id="decodedIDs.companyID"
			:height="reportHeight"
		/>
	</div>
</template>

<script>
import { userMixin, reportMixin } from "@mixins";
import PowerBIReport from "@components/PowerBIReport";
import RecProductionReport from "@components/RecProductionReport";
import BDXValidationReport from "@components/BDXValidationReport";

// LIQ-2339/LIQ-2340 - same dispatch table as Dashboard.vue's own NATIVE_REPORT_COMPONENTS, kept
// in sync manually (small, fixed set) rather than shared, since this file uses the Options API.
const NATIVE_REPORT_COMPONENTS = {
	'rec-production-report': RecProductionReport,
	'bdx-validation-report': BDXValidationReport,
};

export default {
	title() {
		return "Loading Report...";
	},
	components: {
		PowerBIReport,
		RecProductionReport,
		BDXValidationReport,
	},
	data() {
		return {
			reportHeight: `100vh`,
			reportsMeta: [],
		};
	},
	inject: ["ReportsService"],
	mixins: [userMixin, reportMixin],
	computed: {
		decodedIDs() {
			return this.decodeReportHash(this.$route.params.id)
		},
		reportName() {
			if (undefined == this.ReportsService.report.reportConfig)
				return null;

			return this.ReportsService.report.reportConfig[0].reportName;
		},
		matchedReportMeta() {
			const targetId = this.decodedIDs.reportID;
			return this.reportsMeta.find((r) => (r.report_id || r.id) === targetId) || null;
		},
		nativeComponent() {
			// "View As" (company impersonation) is never supported for native reports -
			// RecProductionReport has no company-context prop, it only ever knows the real
			// logged-in user's own company/role.
			if (this.decodedIDs.companyID) return null;
			if (!this.matchedReportMeta || !this.matchedReportMeta.is_native) return null;
			return NATIVE_REPORT_COMPONENTS[this.matchedReportMeta.native_component] || null;
		},
	},
	watch: {
		reportName: {
			immediate: true,
			handler(newVal) {
				if (newVal && this.isUserRole("Superuser"))
					this.setPageTitle(newVal);
			},
		},
	},
	async created() {
		try {
			const {
				data: {
					data: { data: reports },
				},
			} = await this.ReportsService.list(null, false);

			this.reportsMeta = reports || [];
		} catch (e) {}
	},
	// Same reasoning as Dashboard.vue's own beforeRouteLeave (LIQ-2339) - this page IS the
	// route-matched component for /reports/:id, so this is the only place vue-router will
	// actually invoke the guard.
	beforeRouteLeave(to, from, next) {
		const nativeRef = this.$refs.nativeReportRef;

		if (nativeRef && 'function' === typeof nativeRef.guardUnsavedChanges && nativeRef.guardUnsavedChanges(() => next())) return;

		next();
	},
	beforeDestroy() {
		this.ReportsService.set("report", null);

		this.$bus.destroyEvents();
	},
};
</script>
